<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none bg-stage-background" tabindex="0">
        <form @submit.prevent="saveVaultName">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h1 class="py-0.5 text-2xl font-semibold text-gray-900">Vault-Beschreibung ändern</h1>
                    </div>
                </div>
            </div>
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="mt-6 shadow sm:rounded-sm border border-bordergray-100 overflow-hidden">
                    <loading :status="loading"/>
                    <div class="bg-white md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
                        <div class="md:col-span-1">
                            <h3 class="text-lg font-medium leading-6 text-gray-900">Vault Details</h3>
                            <p class="mt-1 text-sm leading-5 text-gray-500">
                                Hier kann nur die Beschreibung des Vault-Eintrags geändert werden.
                            </p>
                        </div>
                        <div class="mt-5 md:mt-0 md:col-span-2">
                            <div class="grid grid-cols-1 gap-6">
                                <div>
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="vault-description">Beschreibung</label>
                                    <div class="mt-1 relative">
                                        <textarea
                                            id="vault-description"
                                            ref="descriptionInput"
                                            v-model.trim="form.description"
                                            class="form-textarea block w-full"
                                            rows="4"
                                        ></textarea>
                                    </div>
                                </div>
                                <p v-if="errorMessage" class="text-sm text-red-600">{{ errorMessage }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="stage-footer-surface px-4 py-3 sm:px-6 flex items-center justify-end">
                        <span class="inline-flex items-center">
                            <router-link
                                :to="vaultBasePath + '/' + vaultId + '/manage'"
                                class="btn-stage-secondary mr-4"
                            >
                                Abbrechen
                            </router-link>
                            <button class="btn-stage-primary" type="submit">
                                Beschreibung speichern
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </form>
    </main>
</template>

<script>
export default {
    name: "vault-rename",
    metaInfo() {
        return {
            title: "Vault-Beschreibung ändern"
        };
    },
    data() {
        return {
            loading: false,
            errorMessage: '',
            form: {
                description: '',
            },
        };
    },
    computed: {
        vaultId() {
            return this.$route.params.id;
        },
        vaultBasePath() {
            return this.$route.path.startsWith('/workspace/vault') ? '/workspace/vault' : '/vault';
        },
        apiVaultBasePath() {
            return this.$route.path.startsWith('/workspace/vault') ? 'api/workspace/vault' : 'api/vault';
        },
        vaultListPath() {
            return this.vaultBasePath === '/workspace/vault' ? '/workspace/vault' : '/vault/list';
        },
    },
    mounted() {
        this.loadVault();
    },
    methods: {
        loadVault() {
            const self = this;
            self.loading = true;
            axios.get(self.apiVaultBasePath + '/' + self.vaultId).then(function (response) {
                self.form.description = response.data && response.data.description ? response.data.description : '';
                self.$nextTick(() => {
                    if (self.$refs.descriptionInput) {
                        self.$refs.descriptionInput.focus();
                    }
                });
            }).catch(function (error) {
                self.errorMessage = self.getApiErrorMessage(error, 'Eintrag konnte nicht geladen werden.');
                self.$router.push(self.vaultListPath);
            }).finally(function () {
                self.loading = false;
            });
        },
        saveVaultName() {
            const self = this;
            this.errorMessage = '';
            if (!this.form.description || this.form.description.trim().length < 3) {
                this.errorMessage = 'Die Beschreibung muss mindestens 3 Zeichen enthalten.';
                return;
            }
            self.loading = true;
            axios.put(self.apiVaultBasePath + '/' + self.vaultId, {
                short_description: self.form.description,
            }).then(function (response) {
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: response.data && response.data.message ? response.data.message : 'Beschreibung wurde aktualisiert.',
                    type: 'success'
                });
                self.$router.push(self.vaultBasePath + '/' + self.vaultId + '/manage');
            }).catch(function (error) {
                self.errorMessage = self.getApiErrorMessage(error, 'Beschreibung konnte nicht aktualisiert werden.');
            }).finally(function () {
                self.loading = false;
            });
        },
        getApiErrorMessage(error, fallback) {
            if (error && error.response && error.response.data) {
                const responseData = error.response.data;
                if (responseData.message) {
                    return responseData.message;
                }
                if (responseData.errors && typeof responseData.errors === 'object') {
                    const firstField = Object.keys(responseData.errors)[0];
                    if (firstField && responseData.errors[firstField] && responseData.errors[firstField][0]) {
                        return responseData.errors[firstField][0];
                    }
                }
            }
            return fallback;
        }
    }
}
</script>
